import { api } from '../../Controllers/api'

const requestReports = () => {
  return {
    type: 'REQUEST_REPORTS',
    loading: true
  }
}

const requestReport = () => {
  return {
    type: 'REQUEST_REPORT',
    loading: true
  }
}

const receiveReports = reportList => {
  return {
    type: 'RECEIVE_REPORTS',
    payload: { reportList }
  }
}

const createdReport = newReport => {
  return {
    type: 'CREATE_REPORT',
    payload: { newReport },
    loading: false
  }
}

const receivedReport = reportDetail => {
  return {
    type: 'RECEIVE_REPORT',
    payload: { reportDetail },
    loading: false
  }
}

const clearReport = () => {
  return {
    type: 'CLEAR_REPORT'
  }
}

const getReports = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestReports())
    }
    api.get(`reports`).then(({ data }) => {
      dispatch(receiveReports(data))
    })
  }
}

const getReport = id => {
  return dispatch => {
    // dispatch(requestReport())
    api.get(`reports/${id}`).then(({ data }) => {
      dispatch(receivedReport(data))
    })
  }
}

const createReport = body => {
  return dispatch => {
    api.post(`reports`, body).then(({ data }) => {
      dispatch(createdReport({ ...body, _id: data.insertedId, delete: false }))
    })
  }
}

export { getReports, createReport, getReport, clearReport }
